/*
 * 验证手机号是否合格
 * true--说明合格
 */
export function isCellPhone(rule, value, callback) {
  const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的手机号！'));
    } else {
      callback();
    }
  }
}
/*
 * 验证身份证号是否合格
 * true--说明合格
 */
export function isIdCard(rule,idCardStr, callback) {
  let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (idcardReg.test(idCardStr)) {
    callback();
  } else {
    callback(new Error('请输入正确的身份证号！'));
  }
}

// 是否为6位数的密码（数字和字母组成的）
export function validatePassWord(rule, value, callback) {
  const reg = /^[0-9A-Za-z]{6,}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入6位数字或字母的密码'));
    } else {
      callback();
    }
  }
}

export function timestamp(url,data){  //获取当前时间戳
  let newTime = new Date();
  return newTime.getTime();
};


export default {
  isCellPhone,
  isIdCard,
  validatePassWord,
  timestamp
}



// WEBPACK FOOTER //
// ./src/utils/proof-technique.js